import {formatDate, formatDateTime, formatDateTimeISO, formatDateISO, formatTime} from "../dateUtils";
import { formatPrice, formatNumber, floatify, normalizePriceToMysql, normalizePriceToApp } from "../numberUtils";

const manifest = require('../../../../../deploy-manifest.json');

const versionAsset = function (url) {
  let version = Date.now();

  if (manifest.commit) {
      version = manifest.commit;
  }

  return `${url}?v=${version}`;
};

const clone = function (obj, defaultValue = undefined) {
  if (typeof obj === 'undefined') {
    return defaultValue;
  }

  return JSON.parse(JSON.stringify(obj));
};

const parseLocaleNumber = function (stringNumber, locale) {
  const numberFormatLocale = locale.replace('_', '-');

  var thousandSeparator = Intl.NumberFormat(numberFormatLocale).format(11111).replace(/\p{Number}/gu, '');
  var decimalSeparator = Intl.NumberFormat(numberFormatLocale).format(1.1).replace(/\p{Number}/gu, '');

  return parseFloat(`${stringNumber}`
    .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
    .replace(new RegExp('\\' + decimalSeparator), '.')
    .replace(/[^\d.-]/g,'')
  );
};

const getCurrencySymbol = function (locale, currency) {
  return Number(0).toLocaleString(
    locale.replace('_', '-'),
    {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).replace(/\d/g, '').trim()
};

const pluralizeWithTranslation = function (translationString, count) {
  return count > 1 ? window.i18next.t(translationString + '.plural') : window.i18next.t(translationString + '.singular');
};

const formatDistance = function (distance, unit = null) {
  unit = unit || window.distanceUnit;
  return `${distance} ${unit}`;
};

const old = function (inputName, defaultValue = null) {
  return (inputName in window.old && window.old[inputName]) || defaultValue;
};

function round(num, precision = 2) {
  return Math.round((num + Number.EPSILON) * 100) / (10 ** precision);
}
window.round = round;

window.getHolidays = function (startDate, endDate, regionIds) {
  var params = new URLSearchParams({
    startDate: startDate.format('YYYY-MM-DD HH:mm'),
    endDate: endDate.format('YYYY-MM-DD HH:mm'),
  });
  for (const regionId of regionIds) {
    params.append('regionIds[]', regionId);
  }
  return fetch(`${marketHolidaysUrl}?${params}`)
    .then(response => response.json())
    .then(response => {
      return response.data;
    });
};

window.getSeasons = function (startDate, endDate, regionIds) {
  var params = new URLSearchParams({
    startDate: startDate.format('YYYY-MM-DD HH:mm'),
    endDate: endDate.format('YYYY-MM-DD HH:mm'),
  });
  for (const regionId of regionIds) {
    params.append('regionIds[]', regionId);
  }
  return fetch(`${marketSeasonsUrl}?${params}`)
    .then(response => response.json())
    .then(response => {
      return response.data;
    });
};


window.getSpecialPeriods = function (startDate, endDate, regionIds, carTypeGroupIds) {
  var params = new URLSearchParams({
    startDate: startDate.format('YYYY-MM-DD HH:mm'),
    endDate: endDate.format('YYYY-MM-DD HH:mm'),
  });
  for (const regionId of regionIds) {
    params.append('regionIds[]', regionId);
  }
  for (const carTypeGroupId of carTypeGroupIds) {
    params.append('carTypeGroupIds[]', carTypeGroupId);
  }
  return fetch(`${marketSpecialPeriodsUrl}?${params}`)
    .then(response => response.json())
    .then(response => {
      return response.data;
    })
    ;
};

window.checkCampaignCode = function (code) {
  let $campaignCodeField = $('#campaignCode');
  vm.campaignDiscount = 0;
  vm.campaignError = '';

  if ($campaignCodeField.prop('disabled') === false && code.length > 0) {
    if (vm.campaignInfo.code !== code) {
      showGlobalOverlay();

      var params = new URLSearchParams({
        'code': code,
        'department_id': vm.calc.departmentId,
        'car_type_id': vm.selectedCar.type,
      });
      return fetch(`${window.campaignInfoUrl}?${params}`, {method: 'GET'})
        .then(response => response.json())
        .then(response => {
          hideGlobalOverlay();
          if (response.status) {
            response.code = code;
            vm.campaignInfo = response;
            vm.updateCampaignDiscount(response);
          } else {
            vm.campaignError = response.message;
          }

          return response;
        }).catch(function () {
          hideGlobalOverlay();
        });
    } else {
      vm.updateCampaignDiscount(vm.campaignInfo);
    }
  }

  return Promise.resolve(vm.campaignInfo);
};

export const generalMixins = {
  methods: {
    formatPrice,
    formatNumber,
    formatDate,
    formatDateISO,
    formatDateTime,
    formatDateTimeISO,
    formatTime,
    floatify,
    clone,
    versionAsset,
    normalizePriceToMysql,
    normalizePriceToApp,
    parseLocaleNumber,
    getCurrencySymbol,
    pluralizeWithTranslation,
    formatDistance,
    old,
    round,
  }
};

export default generalMixins;

export const mixins = {
  install: (app, options) => {
    app.config.globalProperties.formatDate = formatDate;
    app.provide('formatDate', formatDate);

    app.config.globalProperties.formatDistance = formatDistance;
    app.provide('formatDistance', formatDistance);

    app.config.globalProperties.formatPrice = formatPrice;
    app.provide('formatPrice', formatPrice);

    app.config.globalProperties.old = old;
    app.provide('old', old);

    app.config.globalProperties.round = round;
    app.provide('round', round);

    app.config.globalProperties.getCurrencySymbol = getCurrencySymbol;
    app.provide('getCurrencySymbol', getCurrencySymbol);
  }
}
